
import Vue from 'vue'
import AppMixin from '@/_mixins/app'
import DialogTemplate from '@/_components/dialog/template/template.vue'
import { offboard } from '@/views/Authorization/utils/authorization'

const UserOffboardDialog = Vue.extend({
    mixins: [AppMixin],
    components: { DialogTemplate },
    props: {
        props: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            loading: false,
            offboardError: false,
            offboardProjectUsers: [] as Array<Record<string, any>>,
            offboarded: [] as Array<Record<string, any>>,
        }
    },

    computed: {
        user(): Record<string, any> {
            return this.props.user
        },
        projectUsers(): Record<string, any> {
            return this.props.user.projectUsers
        },
        username() {
            return this.user.user ? this.user.user.name : this.user.email
        },
        // If during offboarding there is an error, fe saves the projectUsers that wasn't offboarded and removes them from projectUsers
        projectUsersFiltered() {
            return this.lodash.difference(this.projectUsers, this.offboarded)
        },

        selectedAll() {
            return this.offboardProjectUsers.length === this.projectUsersFiltered.length
        },

        selectedSome() {
            return this.offboardProjectUsers.length > 0 && !this.selectedAll
        },

        icon() {
            if (this.selectedAll) return 'fas fa-times-square'
            if (this.selectedSome) return 'fas fa-minus-square'
            return 'fal fa-square'
        },
    },

    methods: {
        toggleAll() {
            this.$nextTick(() => {
                if (this.selectedAll) {
                    this.offboardProjectUsers = []
                } else {
                    this.offboardProjectUsers = this.projectUsersFiltered.slice()
                }
            })
        },

        async offboard() {
            this.loading = true

            await Promise.all(
                this.offboardProjectUsers.map(async (projectUser: Record<string, any>, index) => {
                    let res = await offboard(projectUser).catch(() => {
                        //
                    })
                    if (res.id) {
                        this.offboardProjectUsers.splice(index, 1)
                        this.offboarded.push(projectUser)
                    }
                })
            )

            // Show error if not all projectUsers have been offboarded
            if (this.offboardProjectUsers.length > 0) {
                this.offboardError = true
            } else {
                this.$emit('close', this.offboarded)
            }
            this.loading = false
        },
    },
    mounted() {
        this.offboardProjectUsers = [...this.projectUsersFiltered]
    },
})

export default UserOffboardDialog
